<template>
  <div class="source-viewer">
    <div
      v-for="item in lines"
      :key="item.line"
      class="line"
      :class="{ 'is-error': item.isError }"
    >
      <span class="line-num">{{ padLineNum(item.line) }}</span>
      <span class="line-content">{{ item.content }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface SourceLine {
  line: number;
  content: string;
  isError: boolean;
}

const props = defineProps<{
  lines: SourceLine[];
}>();

const maxLineNum = computed(() =>
  props.lines.length > 0
    ? String(props.lines[props.lines.length - 1].line).length
    : 1,
);

function padLineNum(n: number): string {
  return String(n).padStart(maxLineNum.value, " ");
}
</script>

<style scoped>
.source-viewer {
  font-family:
    "SF Mono", Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New",
    monospace;
  font-size: 13px;
  line-height: 1.7;
  background: #1e1e1e;
  color: #d4d4d4;
  border-radius: 6px;
  overflow-x: auto;
  padding: 12px 0;
}

.line {
  display: flex;
  white-space: pre;
  padding: 0 16px;
}

.line.is-error {
  background: rgba(244, 63, 94, 0.15);
}

.line.is-error .line-num {
  color: #f43f5e;
  font-weight: 600;
}

.line-num {
  color: #6e7681;
  user-select: none;
  min-width: 3ch;
  text-align: right;
  margin-right: 16px;
  flex-shrink: 0;
}

.line-content {
  color: #e6edf3;
}
</style>
